import moment from 'moment';
import { FallbackEpisode } from '../../../types/fallbackTrackingTypes';
import { toReportRow } from '../../bushistorybybusnumber/csvReports';

/** Formats a number of seconds as `[-]m:ss`; empty when the value is not available. */
export function formatSeconds(seconds?: number | null): string {
    if (seconds === null || seconds === undefined)
        return '';
    const sign = seconds < 0 ? '-' : '';
    return sign + moment.utc(Math.abs(seconds) * 1000).format(Math.abs(seconds) >= 3600 ? 'H:mm:ss' : 'm:ss');
}

const formatDateTime = (time: string) => moment.parseZone(time).format('YYYY-MM-DD hh:mm:ss A');

const FallbackEpisodesReportDef = [
    { header: 'Route', getter: (e: FallbackEpisode) => e.routeShortName },
    { header: 'Vehicle', getter: (e: FallbackEpisode) => e.vehicleId },
    { header: 'Trip', getter: (e: FallbackEpisode) => e.tripId },
    { header: 'Last Position', getter: (e: FallbackEpisode) => formatDateTime(e.start) },
    { header: 'Next Position', getter: (e: FallbackEpisode) => formatDateTime(e.end) },
    { header: 'Fallback End', getter: (e: FallbackEpisode) => formatDateTime(e.fallbackEnd) },
    { header: 'Gap (sec)', getter: (e: FallbackEpisode) => e.durationSec },
    { header: 'Kept Delay (sec)', getter: (e: FallbackEpisode) => e.observedDelaySec },
    { header: 'Outcome', getter: (e: FallbackEpisode) => e.outcome },
];

export const FallbackEpisodesReportHeaders = FallbackEpisodesReportDef.map(column => column.header);

export const toFallbackEpisodesReport = (episodes: FallbackEpisode[]): object[] =>
    episodes.map(e => toReportRow(FallbackEpisodesReportDef, e));
